import { UserAuthContext } from "context/UserAuthContext";
import MainLayout from "layout/MainLayout";
import { useContext } from "react";
import { Navigate } from "react-router-dom";

export const AdminRoute = () => {
    const { isAdmin } = useContext(UserAuthContext);
    if(!isAdmin()){
        return <Navigate to="/" />;
    }
    return <MainLayout />;
  };